<div class="allocation-sheet-breadcrumbs my-4">
    <ng-container *ngFor="let page of field.fieldGroup; let i = index">
        <input
            type="button"
            class="
                cursor-pointer
                underline
                btn-link
                padding-right-20
                no-word-break
                paging-links-padding
            "
            *ngIf="!isPageHidden(i)"
            [ngClass]="{'active-page': activeIndex == i}"
            value="{{ page.props.label || 'Page ' + (i + 1) }}"
            (click)="goToPage(i)"
        />
    </ng-container>
</div>
<div class="row">
    <div class="col">
        <ng-template #fieldComponent autocomplete="nope"></ng-template>
    </div>
</div>
<div class="allocation-sheet-breadcrumbs my-4">
    <ng-container *ngFor="let page of field.fieldGroup; let i = index">
        <input
            type="button"
            class="
                cursor-pointer
                underline
                btn-link
                padding-right-20
                no-word-break
                paging-links-padding
            "
            *ngIf="!isPageHidden(i)"
            [ngClass]="{'active-page': activeIndex == i}"
            value="{{ page.props.label || 'Page ' + (i + 1) }}"
            (click)="goToPage(i)"
        />
    </ng-container>
</div>
